import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const savedLanguage = localStorage.getItem('language') || 'fr';

i18n
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          // Sign :
          "french": "French",
          "english": "English",
          "signin": "Sign in",
          "signup": "Sign up",
          "username": "Username",
          "username-or-email": "Username or email",
          "email": "Email Address",
          "password": "Password",
          "remember-me": "Remember me",
          "forget-password": "Forget Password?",
          "or-login-email": "or login with email",
          "signin-with-google": "Sign in with Google",
          "confirm-password": "Confirm Password",
          "or-signin": "or sign in",
          "or-signup": "or sign up",

          // Navigation :
          "all": "All",
          "women": "Women",
          "men": "Men",
          "shop": "Shop",
          "stores": "Stores",
          "about": "About",
          "get-free-delivery": "Get free delivery on orders over {{price}}",

          // Home :
          "hero-carousel-text": {
            "item1": "Discover Your Perfect Style",
            "item2": "New Collections Arriving Weekly",
            "item3": "Elevate Your Wardrobe",
            "item4": "Fashion That Speaks Your Language",
            "item5": "Luxury Meets Comfort",
          },
          "hero-carousel-fixed-text": "Experience the latest trends in fashion and style",
          "shop-now": "Shop Now",

          // Product List :
          "products": "Products",
          "new-products": "New products",
          "our-new-collection": "Our new collection",
          "categories": "Categories",
          "our-products-categories": "Our products categories",

          "category-carousel": {
            "tracksuits": "Tracksuits",
            "sweatshirts": "Sweatshirts & Zippers",
            "jackets": "Jackets",
            "jeans": "Jeans & Cargos",
            "shirts": "Shirts & Tops",
            "jerseys": "Jerseys",
            "accessories": "Accessories",
          },
          "view-all": "View all",

          // Footer :
          "logo-footer-text": "Thunder is a Moroccan brand and shop that merges different universes of clothing, with a focus on streetwear style, offering the best quality and original worldwide brands.",
          "product-categories": "Product categories",
          "customer-service": {
            "item1": "Customer Service",
            "item2": "Contact Us",
            "item3": "FAQ",
            "item4": "Shipping & Returns",
            "item5": "Order Tracking"
          },
          "about-us": {
            "item1": "About us",
            "item2": "Our story",
            "item3": "Sustainability",
            "item4": "Careers",
            "item5": "Press"
          },
          "copyright": "© Copyright 2025. All rights reserved.",

          // Shop :
          "all-our-products": "All our products",
          "all-products": "All products",

          // Shopping cart :
          "shopping-cart": "Shopping cart",
          "remove": "Remove",
          "subtotal": "Subtotal",
          "shipping-text": "Shipping and taxes calculated at checkout.",
          "or": "or",
          "continue-shopping": "Continue Shopping",
          "checkout": "Checkout",

          // Search :
          "search-products": "Search products",
          "search-customers": "Search customers",
          "no-found-title": "No results found",
          "no-found-text": "Try adjusting your search to find what you're looking for.",
          "results-found": "Results found",

          // Toast :
          "s-login": "Login successful!",
          "e-login": "Login failed. Please try again.",
          "s-register": "Registration successful!",
          "e-register": "Registration failed. Please try again.",
          "error-not-match": "Passwords do not match",
          "error-unique-username": "This username is already taken.",
          "error-unique-email": "This email is already registered.",

          // Dashboard (English):
          "all-categories": "All categories",
          "add-category": "Add category",
          "all-sizes": "All sizes",
          "add-size": "Add size",
          "search-sizes": "Search sizes...",
          "add-size-success": "Size added successfully!",
          "add-size-error": "Error adding size.",
          "create": "Create",
          "edit": "Edit",
          "cancel": "Cancel",
          "search-categories": "Search categories...",
          "add-category-success": "Category added successfully!",
          "add-category-error": "Error adding category.",
          "add-bag-success": "The item is added to the bag!",
          "add-bag-error": "Error adding the item to the bag.",

          // Edit action (English):
          "edit-category-success": "Category edited successfully!",
          "edit-size-success": "Size edited successfully!",
          "edit-size-error": "Error editing size.",
          "edit-category-error": "Error editing category.",

          // Delete action (English):
          "delete-confirmation-header": "Confirm Deletion",
          "delete-confirmation-body": "Are you sure you want to delete this item? This action cannot be undone.",

          "delete-category-success": "Category deleted successfully!",
          "delete-size-success": "Size deleted successfully!",
          "delete-size-error": "Error deleting size.",
          "delete-category-error": "Error deleting category.",
          "delete-order-success": "Order deleted successfully!",
          "delete-order-error": "Error deleting order.",
          "delete-review-success": "Review deleted successfully!",
          "delete-review-error": "Error deleting review.",
          "logout-confirmation-header": "Confirm Logout",
          "logout-confirmation-body": "Are you sure you want to logout?",

          "category-id": "Category ID",
          "size-id": "Size ID",
          "sizes": "Sizes",
          "size": "Size",
          "name": "Name",
          "description": "Description",
          "actions": "Actions",
          "quantity": "Quantity",
          "confirm": "Confirm",

          "view": "view",
          "quick-view": "quick view",
          "reviews": "reviews",
          "add-bag": "Add to bag",
          "recent-reviews": "Recent reviews",
          "review-text": {
            "item1": "Share your thoughts",
            "item2": "If you've used this product, share your thoughts with other customers",
          },
          "write-review": "Write a review",
          "submit": "Submit",
          "addreview": "Add a review",
          "outof": "out of",
          "review-desc": "The comment",

          "s-add-rev": "Review added successfully!",
          "e-add-rev": "Failed to add review. Please try again.",
          "s-remove-rev": "Review removed successfully!",
          "e-remove-rev": "Failed to remove review. Please try again.",
          "see-more": "See more",
          "see-less": "See less",
          "size-warning": "You must determine the size!",
          "of": "of",

          // Filter :
          "category": "Category",
          "gender": "Gender",
          "availability": "Availability",
          "sort": "Sort",
          "in-stock": "In Stock",
          "out-of-stock": "Out of Stock",
          "name-a-z": "Name (A to Z)",
          "name-z-a": "Name (Z to A)",
          "price-low-high": "Price (Low to High)",
          "price-high-low": "Price (High to Low)",
          "newest": "Newest First",
          "oldest": "Oldest First",

          "logout": "Log out",
          "logout-msg": "Logged out successfully",
          "logout-msg-err": "Log out failed",
          "empty-bag": "Your bag is currently empty.",
          "unauth-bag": {
            "item1": "You need to",
            "item2": "sign up",
            "item3": "to add items to your bag.",
            "item4": "If you already have an account, please",
            "item5": "sign in.",
          },

          // Account setting :
          "settings": "Settings",
          "account": "Account",
          "hello": "Hello",
          "hello-1": "From your account dashboard you can view your recent orders, manage your shipping and billing addresses, and edit your password and account details.",
          "orders": "Orders",
          "dashboard": "Dashboard",
          "payment": "Payment",
          "account-details": "Account details",

          "all-orders": "All orders",
          "all-orders-1": "No order has been made yet.",
          "all-orders-2": "Browse products",

          "purchases": "Purchases",
          "my-purchases": "My purchases",
          "all-purchases": "All my purchases",
          "all-purchases-1": "No purchase has been made yet.",
          "all-purchases-2": "Browse products",

          "add-payment": "Add payment method",
          "all-payment-methods": "All my payment methods",

          "fullname": "Full name",
          "ur-fullname": "Your full name",
          "fname": "First name",
          "lname": "Last name",
          "save": "Save",
          "leave-blank": "leave blank to leave unchanged",

          "edit-username": "Your current username is",
          "new-name": "You can add the full name here",
          "edit-name": "Your current full name is",
          "edit-email": "Email Address",
          "edit-email-1": "Your current email is",
          "edit-password": "Password change",
          "edit-password-1": "Do you want to change your",
          "edit-password-2": "current password",
          "current-password": "Current password",
          "new-password": "New password",
          "conf-new-password": "Confirm new password",
          "error-username": "The username has already been taken",
          "s-up-username": "Username updated successfully!",
          "e-up-username": "Failed to update username. Please try again.",
          "s-up-email": "Email updated successfully!",
          "e-up-email": "Failed to update email. Please try again.",
          "s-up-psw": "Password updated successfully!",
          "e-up-psw": "Failed to update password. Please try again.",
          "e-current-psw": "The current password is incorrect.",

          // checkout :
          "phone": "Phone",
          "city": "City",
          "ur-city": "Your city",
          "ur-phone": "Your phone",
          "country": "Country",
          "morocco": "Morocco",
          "ur-country": "Your country",
          "postcode": "Post code",
          "ur-postcode": "Your post code",
          "ppayment": "Payment",
          "credit-card": "Credit card",
          "cardnumber": "Card number",
          "cardexpiration": "Card expiration",
          "expirationdate": "Expiration date",
          "placeorder": "Place order",
          "address-line": "Address line",
          "ur-address-line": "Your address line",

          // dashboard product :
          "add-product-success": "Product added successfully!",
          "add-product-error": "Failed to add product.",
          "update-product-success": "Product updated successfully!",
          "update-product-error": "Failed to update product.",
          "delete-product-success": "Product deleted successfully!",
          "delete-product-error": "Failed to delete product.",

          "region": "Region",
          "select-city": "Select city",
          "select-region": "Select region",
          "payment-details": "Détails du paiement",
          "process-payment-success": "Thank you so much for your order! We truly appreciate your purchase.",
          "process-payment-error": "Error processing payment.",
          "date&time": "Date & time",
          "payment-method": "Payment method",
          "my-transactions": "My transactions",
          "all-transactions": "All transactions",
          "all-transactions-1": "No transaction has been made yet.",
          "amount": "Amount",
          "total-amount": "Total amount",
          "warning-rating-required": "Please select a rating before submitting your review.",
          "login-fill-form-warning": "Please fill in all fields.",

          "customer": "Customer",
          "create-account": "Create an account",
          "date-reg": "Date of registration",
          "delete": "delete",
          "delete-customer-success": "Customer deleted successfully!",
          "delete-customer-error": "Failed to delete customer.",
          "recommended-for-you": "Recommended for You",
          "our-products": "Our products",
          "preview": "Preview",

          "duplicate-product":"Duplicate the product",
          "confirm-duplicate-product-header": "Confirm Duplicate Product",
          "confirm-duplicate-product-text": "Are you sure you want to duplicate this product?",
          "duplicate-product-success-toast": "Product duplicated successfully!",
          "duplicate-product-error-toast": "Failed to duplicate product.",

          "slide": "Slide",
          "slides": "Slides",
          "all-slides": "All slides",
          "search-slides": "Search slides",
          "add-slide": "Add slide",
          "delete-slide-success": "Slide deleted successfully!",
          "delete-slide-error": "Failed to delete slide.",
          "update-slide-success": "Slide updated successfully!",
          "update-slide-error": "Failed to update slide.",
          "create-slide-success": "Slide created successfully!",
          "create-slide-error": "Failed to create slide.",

          // Color :
          "all-colors": "All colors",
          "add-color": "Add color",
          "search-colors": "Search colors...",
          "search-orders": "Search orders...",
          "search-transactions": "Search transactions...",
          "add-color-success": "Color added successfully!",
          "add-color-error": "Error adding color.",
          "color-warning": "You must determine the color!",
          "edit-color-success": "Color edited successfully!",
          "edit-color-error": "Error editing color.",
          "delete-color-success": "Color deleted successfully!",
          "delete-color-error": "Error deleting color.",
          "color-id": "Color ID",
          "order-id": "Order ID",
          "colors": "Colors",
          "color": "Color",
          "guest": "Guest",
          "customer-type": "Customer type",
          "pay": "Pay",
          "reference": "Reference",
          "address": "Address",
          "status": "Status",

          "pending": "Pending",
          "in_progress": "In progress",
          "completed": "Completed",
          "canceled": "Canceled",
          "out-for-delivery": "Out for delivery",
          "delivered": "Delivered",
          "cash-on-delivery": "Cash on delivery",
          "order-date": "Order date",

          "delivery-status": "Delivery Status",
          "select-delivery-status": "Select delivery status",
          "order-status": "Order Status",
          "select-order-status": "Select order status",
          "save-changes": "Save Changes",

          "save-order-details-success": "Changes to order details saved successfully!",
          "save-order-details-error": "Failed to save changes to order details.",

          "back": "Back",
          "crs-create-slide": "Create New Slide",
          "crs-slide-description": "Fill in the details below to create a new slide.",
          "carousel-image-area-note-1": "PNG, JPG or PDF, smaller than 5MB",
          "carousel-image-area-note-2": "For best display, please upload images with a 16:9 aspect ratio.",
          "crs-drop-and-drag": "Drag and Drop your file here or",
          "crs-choose-file": "Choose File",
          "crs-create-slide-button": "Create Slide",
          "file-name": "File name",
          "crs-update-slide": "Update The Slide",
          "crs-update-slide-description": "Fill in the details below to update the slide.",
          "crs-update-slide-button": "Update Slide",
          "name-card": "Name on card",
          "ur-name-card": "Your name on card",

          "co-credit-card": "Credit Card Details",
          "pay-paypal": "Pay with PayPal",
          "pay-paypal-text": "You will be redirected to PayPal to complete your payment securely.",
          "cash-delivery": "Cash on Delivery",
          "cash-delivery-text-1": "Pay with cash when your order is delivered to your doorstep.",
          "cash-delivery-text-2": "Have the exact amount ready",
          "cash-delivery-text-3": "Our delivery person will provide a receipt",
          "pay-delivery": "Pay on Delivery",
          "details": "Details",
          "order-details": "Order details",
          "customer-info": "Customer Information",
          "order-items": "Order Items",
          "stock-management": "Stock management",
          "stock-total": "Stock total",
          "rating": "Rating",
          "price": "Price",

          "edit-stock-success": "Stock edited successfully!",
          "edit-stock-error": "Error editing stock.",
          "delete-stock-success": "Stock cleared successfully!",
          "delete-stock-error": "Error clearing stock.",
          "stock-msg": "The stock being added will apply to all sizes of the product.",
          "back-to-products": "Back to products",
          "insufficient-stock": "Insufficient stock",
          
          "": "",
        }
      },
      fr: {
        translation: {
          // Sign :
          "french": "Français",
          "english": "Anglais",
          "signin": "Se connecter",
          "signup": "S'inscrire",
          "username": "Nom d'utilisateur",
          "username-or-email": "Nom d'utilisateur ou e-mail",
          "email": "Adresse e-mail",
          "password": "Mot de passe",
          "remember-me": "Souviens-toi de moi",
          "forget-password?": "Mot de passe oublié?",
          "or-login-email": "ou se connecter avec un e-mail",
          "signin-with-google": "Se connecter avec Google",
          "confirm-password": "Confirmer le mot de passe",
          "or-signin": "ou se connecter",
          "or-signup": "ou s'inscrire",

          // Navigation :
          "all": "Tout",
          "women": "Femmes",
          "men": "Hommes",
          "shop": "Boutique",
          "stores": "Magasins",
          "about": "À propos",
          "get-free-delivery": "Livraison gratuite pour les commandes de plus de {{price}}",

          // Home :
          "hero-carousel-text": {
            "item1": "Découvrez Votre Style Parfait",
            "item2": "Nouvelles Collections Arrivant Hebdomadairement",
            "item3": "Élevez Votre Garde-robe",
            "item4": "La Mode Qui Parle Votre Langage",
            "item5": "Le Luxe Rencontre le Confort",
          },
          "hero-carousel-fixed-text": "Découvrez les dernières tendances de la mode et du style",
          "shop-now": "Achetez Maintenant",

          // Product List :
          "products": "Produits",
          "new-products": "Nouveaux produits",
          "our-new-collection": "Notre nouvelle collection",
          "Categories": "Catégories",
          "Our products categories": "Nos catégories de produits",

          "category-carousel": {
            "tracksuits": "Survêtements",
            "sweatshirts": "Sweat-shirts & Zippés",
            "jackets": "Vestes",
            "jeans": "Jeans & Cargos",
            "shirts": "Chemises & Hauts",
            "jerseys": "Maillots",
            "accessories": "Accessoires",
          },
          "view-all": "Voir tout",

          // Footer :
          "logo-footer-text": "Thunder est une marque et une boutique marocaine qui fusionne différents univers vestimentaires, avec un accent sur le style streetwear, offrant la meilleure qualité et des marques mondiales originales.",
          "product-categories": "Catégories de produits",
          "customer-service": {
            "item1": "Service client",
            "item2": "Nous contacter",
            "item3": "FAQ",
            "item4": "Expéditions & Retours",
            "item5": "Suivi de commande"
          },
          "about-us": {
            "item1": "À propos de nous",
            "item2": "Notre histoire",
            "item3": "Durabilité",
            "item4": "Carrières",
            "item5": "Presse"
          },
          "copyright": "© Copyright 2025. Tous droits réservés.",

          // Shop :
          "all-our-products": "Tous nos produits",
          "all-products": "Tous les produits",

          // Shopping cart :
          "shopping-cart": "Panier",
          "remove": "Retirer",
          "subtotal": "Sous-total",
          "shipping-text": "Les frais d'expédition et les taxes sont calculés à la caisse.",
          "or": "ou",
          "continue-shopping": "Continuer vos achats",
          "checkout": "Passer à la caisse",

          // Search :
          "search-products": "Rechercher des produits",
          "search-customers": "Rechercher des clients",
          "no-found-title": "Aucun résultat trouvé",
          "no-found-text": "Essayez d'ajuster votre recherche pour trouver ce que vous cherchez.",
          "results-found": "Résultats trouvés",

          // Toast :
          "s-login": "Connexion réussie !",
          "e-login": "Échec de la connexion. Veuillez réessayer.",
          "s-register": "Inscription réussie !",
          "e-register": "Échec de l'inscription. Veuillez réessayer.",
          "error-not-match": "Les mots de passe ne correspondent pas",
          "error-unique-username": "Ce nom d'utilisateur est déjà pris.",
          "error-unique-email": "Cet e-mail est déjà enregistré.",

          // Dashboard (French):
          "all-categories": "Toutes les catégories",
          "all-sizes": "Toutes les tailles",
          "add-category": "Ajouter une catégorie",
          "add-size": "Ajouter une taille",
          "create": "Créer",
          "edit": "Modifier",
          "cancel": "Annuler",
          "search-categories": "Rechercher des catégories...",
          "search-sizes": "Rechercher des tailles...",
          "add-category-success": "Catégorie ajoutée avec succès !",
          "add-size-success": "Taille ajoutée avec succès !",
          "add-category-error": "Erreur lors de l'ajout de la catégorie.",
          "add-size-error": "Erreur lors de l'ajout de la taille.",
          "add-bag-success": "L'article est ajouté au panier !",
          "add-bag-error": "Erreur lors de l'ajout de l'article au panier.",

          // Edit action (French):
          "edit-category-success": "Catégorie modifiée avec succès !",
          "edit-size-success": "Taille modifiée avec succès !",
          "edit-category-error": "Erreur lors de la modification de la catégorie.",
          "edit-size-error": "Erreur lors de la modification de la taille.",

          // Delete action (French):
          "delete-confirmation-header": "Confirmer la suppression",
          "delete-confirmation-body": "Êtes-vous sûr de vouloir supprimer cet article ? Cette action est irréversible.",
          "delete-category-success": "Catégorie supprimée avec succès !",
          "delete-size-success": "Taille supprimée avec succès !",
          "delete-category-error": "Erreur lors de la suppression de la catégorie.",
          "delete-size-error": "Erreur lors de la suppression de la taille.",
          "delete-order-success": "Commande supprimée avec succès !",
          "delete-order-error": "Erreur lors de la suppression de la commande.",
          "delete-review-success": "Avis supprimé avec succès!",
          "delete-review-error": "Erreur lors de la suppression de l'avis.",
          "logout-confirmation-header": "Confirmer la déconnexion",
          "logout-confirmation-body": "Êtes-vous sûr de vouloir vous déconnecter ?",

          "category-id": "Catégorie ID",
          "size-id": "Taille ID",
          "sizes": "Tailles",
          "size": "Taille",
          "name": "Nom",
          "description": "Description",
          "actions": "Actions",
          "quantity": "Quantité",
          "confirm": "Confirmer",

          "view": "Voir",
          "quick-view": "Aperçu rapide",
          "reviews": "Avis",
          "add-bag": "Ajouter au panier",
          "recent-reviews": "Avis récents",
          "review-text": {
            "item1": "Partagez vos impressions",
            "item2": "Si vous avez utilisé ce produit, partagez vos impressions avec d'autres clients"
          },
          "write-review": "Écrire un avis",
          "submit": "Envoyer",
          "addreview": "Ajouter un commentaire",
          "outof": "sur",
          "review-desc": "Le commentaire",

          "s-add-rev": "Avis ajouté avec succès!",
          "e-add-rev": "Échec de l'ajout de l'avis. Veuillez réessayer.",
          "s-remove-rev": "Avis supprimé avec succès!",
          "e-remove-rev": "Échec de la suppression de l'avis. Veuillez réessayer.",
          "see-more": "Voir plus",
          "see-less": "Voir moins",
          "size-warning": "Vous devez déterminer la taille !",
          "of": "sur",

          // Filter :
          "category": "Catégorie",
          "gender": "Genre",
          "availability": "Disponibilité",
          "sort": "Trier",
          "in-stock": "En stock",
          "out-of-stock": "Rupture de stock",
          "name-a-z": "Nom (A à Z)",
          "name-z-a": "Nom (Z à A)",
          "price-low-high": "Prix (croissant)",
          "price-high-low": "Prix (décroissant)",
          "newest": "Plus récents",
          "oldest": "Plus anciens",

          "logout": "Déconnexion",
          "logout-msg": "Déconnexion réussie",
          "logout-msg-err": "Échec de la déconnexion",
          "empty-bag": "Votre panier est actuellement vide.",
          "unauth-bag": {
            "item1": "Vous devez vous",
            "item2": "inscrire",
            "item3": "pour ajouter des articles à votre panier.",
            "item4": "Si vous avez déjà un compte, veuillez vous",
            "item5": "connecter.",
          },

          // Account setting :
          "settings": "Paramètres",
          "account": "Compte",
          "hello": "Bonjour",
          "hello-1": "Depuis le tableau de bord de votre compte, vous pouvez voir vos commandes récentes, gérer vos adresses de livraison et de facturation, et modifier votre mot de passe et les détails de votre compte.",
          "orders": "Commandes",
          "dashboard": "Tableau de bord",
          "account-details": "Détails du compte",

          "purchases": "Achats",
          "my-purchases": "Mes achats",
          "all-purchases": "Tous mes achats",
          "all-purchases-1": "Aucun achat n'a encore été effectué.",
          "all-purchases-2": "Parcourir les produits",

          "all-orders": "Toutes les commandes",
          "all-orders-1": "Aucune commande n'a encore été passée.",
          "all-orders-2": "Parcourir les produits",

          "add-payment": "Ajouter un moyen de paiement",
          "all-payment-methods": "Tous mes modes de paiement",

          "fullname": "Nom et prénom",
          "ur-fullname": "Votre nom et prénom",
          "fname": "Prénom",
          "lname": "Nom de famille",
          "save": "Enregistrer",
          "leave-blank": "laisser vide pour ne pas changer",
          "edit-username": "Votre nom d'utilisateur actuel est",
          "new-name": "Vous pouvez ajouter le nom complet ici",
          "edit-name": "Votre nom complet actuel est",
          "edit-email": "Adresse e-mail",
          "edit-email-1": "Votre e-mail actuel est",
          "edit-password": "Changement de mot de passe",
          "edit-password-1": "Voulez-vous changer votre",
          "edit-password-2": "mot de passe actuel?",
          "current-password": "Mot de passe actuel",
          "new-password": "Nouveau mot de passe",
          "conf-new-password": "Confirmer le nouveau mot de passe",
          "error-username": "Le nom d'utilisateur a déjà été utilisé",
          "s-up-username": "Nom d'utilisateur mis à jour avec succès!",
          "e-up-username": "Échec de la mise à jour du nom d'utilisateur. Veuillez réessayer.",
          "s-up-email": "Email mis à jour avec succès!",
          "e-up-email": "Échec de la mise à jour de l'email. Veuillez réessayer.",
          "s-up-psw": "Mot de passe mis à jour avec succès!",
          "e-up-psw": "Échec de la mise à jour du mot de passe. Veuillez réessayer.",
          "e-current-psw": "Le mot de passe courant est incorrect.",

          // checkout :
          "phone": "Téléphone",
          "city": "Ville",
          "ur-city": "Votre ville",
          "ur-phone": "Votre téléphone",
          "country": "Pays",
          "morocco": "Maroc",
          "ur-country": "Votre pays",
          "postcode": "Code postal",
          "ur-postcode": "Votre code postal",
          "payment": "Paiement",
          "credit-card": "Carte de crédit",
          "cardnumber": "Numéro de la carte",
          "cardexpiration": "Expiration de la carte",
          "expirationdate": "Date d'expiration",
          "placeorder": "Passer commande",
          "address-line": "Ligne d'adresse",
          "ur-address-line": "Votre ligne d'adresse",

          // dashboard product :
          "add-product-success": "Produit ajouté avec succès!",
          "add-product-error": "Échec de l'ajout du produit.",
          "update-product-success": "Produit mis à jour avec succès!",
          "update-product-error": "Échec de la mise à jour du produit.",
          "delete-product-success": "Produit supprimé avec succès!",
          "delete-product-error": "Échec de la suppression du produit.",

          "region": "Région",
          "select-city": "Sélectionner une ville",
          "select-region": "Sélectionner une région",
          "payment-details": "Payment details",
          "process-payment-success": "Merci beaucoup pour votre commande! Nous apprécions sincèrement votre achat.",
          "process-payment-error": "Erreur lors du traitement du paiement.",
          "date&time": "Date et heure",
          "my-transactions": "Mes transactions",
          "all-transactions": "Toutes les transactions",
          "all-transactions-1": "Aucune transaction n'a encore été effectuée.",
          "amount": "Montant",
          "total-amount": "Montant total",
          "warning-rating-required": "Veuillez sélectionner une note avant de soumettre votre avis.",
          "login-fill-form-warning": "Veuillez remplir tous les champs.",

          "customer": "Client",
          "create-account": "Créer un compte",
          "date-reg": "Date de l'inscription",
          "delete": "supprimer",
          "delete-customer-success": "Client supprimé avec succès!",
          "delete-customer-error": "Échec de la suppression du client.",
          "recommended-for-you": "Recommandé pour vous",
          "our-products": "Nos produits",
          "preview": "Aperçu",

          "duplicate-product":"Dupliquer le produit",
          "confirm-duplicate-product-header": "Confirmer la duplication du produit",
          "confirm-duplicate-product-text": "Êtes-vous sûr de vouloir dupliquer ce produit?",
          "duplicate-product-success-toast": "Produit dupliqué avec succès!",
          "duplicate-product-error-toast": "Échec de la duplication du produit.",

          "slide": "Diapositive",
          "slides": "Diapositives",
          "all-slides": "Toutes les diapositives",
          "search-slides": "Rechercher des diapositives",
          "add-slide": "Ajouter une diapositive",
          "delete-slide-success": "Diapositive supprimée avec succès!",
          "delete-slide-error": "Échec de la suppression de la diapositive.",
          "update-slide-success": "Diapositive mise à jour avec succès!",
          "update-slide-error": "Échec de la mise à jour de la diapositive.",
          "create-slide-success": "Diapositive créée avec succès!",
          "create-slide-error": "Échec de la création de la diapositive.",

          // Color :
          "all-colors": "Toutes les couleurs",
          "add-color": "Ajouter une couleur",
          "search-colors": "Rechercher des couleurs...",
          "search-orders": "Rechercher des commandes...",
          "search-transactions": "Rechercher des transactions...",
          "add-color-success": "Couleur ajoutée avec succès!",
          "add-color-error": "Erreur lors de l'ajout de la couleur.",
          "edit-color-success": "Couleur modifiée avec succès!",
          "edit-color-error": "Erreur lors de la modification de la couleur.",
          "color-warning": "Vous devez déterminer la couleur!",
          "delete-color-success": "Couleur supprimée avec succès!",
          "delete-color-error": "Erreur lors de la suppression de la couleur.",
          "color-id": "Couleur ID",
          "order-id": "Commande ID",
          "colors": "Couleurs",
          "color": "Couleur",
          "guest": "Invité",
          "customer-type": "Type de client",
          "pay": "Payer",
          "reference": "Référence",
          "address": "Adresse",
          "status": "Statut",

          "pending": "En attente",
          "in_progress": "En cours",
          "completed": "Terminé",
          "canceled": "Annulé",
          "out-for-delivery": "En cours de livraison",
          "delivered": "Livré",
          "cash-on-delivery": "Paiement à la livraison",
          "order-date": "Date de commande",

          "payment-method": "Méthode de paiement",
          "delivery-status": "Statut de livraison",
          "select-delivery-status": "Sélectionner le statut de livraison",
          "order-status": "Statut de la commande",
          "select-order-status": "Sélectionner le statut de la commande",
          "save-changes": "Enregistrer les modifications",

          "save-order-details-success": "Les modifications des détails de la commande ont été enregistrées avec succès!",
          "save-order-details-error": "Échec de l'enregistrement des modifications des détails de la commande.",

          "back": "Retour",
          "crs-create-slide": "Créer un nouveau slide",
          "crs-drop-and-drag": "Glissez-déposez votre fichier ici ou",
          "crs-slide-description": "Remplissez les détails ci-dessous pour créer un nouveau slide.",
          "carousel-image-area-note-1": "PNG, JPG ou PDF, inférieur à 5 Mo",
          "carousel-image-area-note-2": "Pour un meilleur affichage, veuillez télécharger des images avec un ratio d'aspect de 16:9.",
          "crs-choose-file": "Choisir un fichier",
          "crs-create-slide-button": "Créer un slide",
          "file-name": "Nom du fichier",
          "crs-update-slide": "Mettre à jour le slide",
          "crs-update-slide-description": "Remplissez les détails ci-dessous pour mettre à jour le slide.",
          "crs-update-slide-button": "Mettre à jour le slide",
          "name-card": "Nom sur la carte",
          "ur-name-card": "Votre nom sur la carte",

          "co-credit-card": "Détails de la carte de crédit",
          "pay-paypal": "Payer avec PayPal",
          "pay-paypal-text": "Vous serez redirigé vers PayPal pour terminer votre paiement en toute sécurité.",
          "cash-delivery": "Paiement à la livraison",
          "cash-delivery-text-1": "Payez en espèces lorsque votre commande est livrée à votre porte.",
          "cash-delivery-text-2": "Ayez le montant exact prêt",
          "cash-delivery-text-3": "Notre livreur vous fournira un reçu",
          "pay-delivery": "Payer à la livraison",
          "details": "Détails",
          "order-details": "Détails de la commande",
          "customer-info": "Information du client",
          "order-items": "Articles de la commande",
          "stock-management": "Gestion des stocks",
          "stock-total": "Total du stock",
          "rating": "Évaluation",
          "price": "Prix",

          "edit-stock-success": "Stock modifié avec succès !",
          "edit-stock-error": "Erreur lors de la modification du stock.",
          "delete-stock-success": "Stock vidé avec succès!",
          "delete-stock-error": "Erreur lors du vidage du stock.",
          "stock-msg": "Le stock ajouté sera appliqué à toutes les tailles du produit.",
          "back-to-products": "Retour aux produits",
          "insufficient-stock": "Stock insuffisant",

          "": "",
        }
      }
    },
    lng: savedLanguage,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
